"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processPrepare = void 0;
const rxjs_1 = require("rxjs");
const NQError_1 = require("../NQError");
const NQValue_1 = require("../NQValue");
const clientId_1 = require("../util/clientId");
const ajax_1 = require("rxjs/ajax");
const operators_1 = require("rxjs/operators");
const deviceInfoUtils_1 = require("../util/deviceInfoUtils");
const R = __importStar(require("ramda"));
const package_json_1 = __importDefault(require("../../../package.json"));
const RxOp = __importStar(require("rxjs/operators"));
const convertToNQError_1 = require("../util/convertToNQError");
const validateInitResponse = (initValue) => {
    if (initValue.data === null && initValue.status.code === 0) {
        throw (0, NQError_1.createNqError)("Ap-Re-6-100", "Init API returned status code 0 and no data");
    }
    if (initValue.data === null) {
        throw (0, convertToNQError_1.statusModelToNqError)(initValue.status);
    }
    return initValue.data;
};
const processPrepare = (speedtestApi, sdkOptions, options) => {
    const logger = sdkOptions.logger;
    logger.info(`prepare started`);
    const result = speedtestApi.configGet().pipe(
    //configData
    RxOp.map(configResponse => {
        logger.info("Got config", configResponse);
        if (!configResponse.data || configResponse.status.code != 0) {
            throw (0, NQError_1.createNqError)("Ap-Re-4-100", "Config API returned no data");
        }
        const configData = configResponse.data;
        if (configData.isUnderMaintenance) {
            throw (0, NQError_1.createNqError)("Sm-1-190", "System Under Maintenance");
        }
        return configData;
    }), 
    //isIPv6
    RxOp.mergeMap(configData => {
        var _a;
        if (((_a = configData.connection) === null || _a === void 0 ? void 0 : _a.ipVersion) == "v6") {
            return (0, rxjs_1.of)({ configData, isIPv6: true });
        }
        logger.info(`checking for IPv6 connection`);
        return detectIPv6(configData.ipDetectionUrl.ipv6).pipe(RxOp.map(isIPv6 => ({ configData, isIPv6 })));
    }), 
    //remotePort
    RxOp.mergeMap(({ configData, isIPv6 }) => {
        if (isIPv6 || R.isNil(configData.remotePortDetectionUrl)) {
            return (0, rxjs_1.of)({ configData, isIPv6, remotePort: null });
        }
        return detectRemotePort(configData.remotePortDetectionUrl).pipe(RxOp.map(remotePort => ({ configData, isIPv6, remotePort })));
    }), 
    //result
    RxOp.mergeMap(({ configData, isIPv6, remotePort }) => {
        const deviceInfo = (0, deviceInfoUtils_1.GetDeviceInfo)();
        logger.info("Device Info", deviceInfo);
        const dependencyVersions = {};
        dependencyVersions[package_json_1.default.name] = package_json_1.default.version;
        const initRequest = {
            uuid: (0, clientId_1.clientId)(),
            remotePort: remotePort,
            deviceInfo: deviceInfo,
            clientBundleId: sdkOptions.clientBundleId,
            clientVersion: sdkOptions.clientVersion,
            dependencyVersions: dependencyVersions,
            clientQueryString: R.isNil(sdkOptions.clientQueryString) ? undefined : sdkOptions.clientQueryString,
            standAloneMode: options === null || options === void 0 ? void 0 : options.standAloneMode,
            parentSpeedtestId: R.isNil(options === null || options === void 0 ? void 0 : options.parentSpeedtestId) ? undefined : options === null || options === void 0 ? void 0 : options.parentSpeedtestId,
        };
        logger.info(`initRequest`, initRequest);
        return speedtestApi.initialize(initRequest).pipe(RxOp.map(initResponse => {
            var _a;
            logger.info(`initResponse`, initResponse);
            const initData = validateInitResponse(initResponse);
            const prepareResult = (0, NQValue_1.createPrepareResult)(configData, initData, isIPv6);
            const overridedPrepareResult = ((_a = sdkOptions.dataOverride) !== null && _a !== void 0 ? _a : (x => x))(prepareResult);
            logger.info("overridedPrepareResult", overridedPrepareResult);
            return overridedPrepareResult;
        }));
    }));
    return result;
};
exports.processPrepare = processPrepare;
const detectIPv6 = (ipDetectionUrl) => {
    const observer = (0, ajax_1.ajax)({ url: `${ipDetectionUrl}?${Math.random()}`, timeout: 2000, crossDomain: true })
        .pipe((0, operators_1.map)(() => true), // if anything other than error is returned from ajax request, then IPv6 is detected
    (0, operators_1.catchError)(() => (0, rxjs_1.of)(false)) // in case of any error, including timeout after 2 seconds, assume IPv4
    );
    return observer;
};
const detectRemotePort = (remotePortUrl) => {
    return (0, ajax_1.ajax)({ url: `${remotePortUrl}?${Math.random()}`, crossDomain: true }).pipe((0, operators_1.catchError)(err => {
        throw (0, NQError_1.createNqError)("Rp-Cn-2-101", "Remote Port Detection Error", err);
    }), RxOp.map(v => {
        if (v.status != 200) {
            throw (0, NQError_1.createNqError)("Rp-Cn-1-101", "Remote Port Detection Error", v);
        }
        const body = v.response;
        return body.port;
    }));
};
//# sourceMappingURL=prepare.js.map